import { render, staticRenderFns } from "./CuentanosComp.vue?vue&type=template&id=315e206e&"
var script = {}
import style0 from "./CuentanosComp.vue?vue&type=style&index=0&id=315e206e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports